/** SemVer core plus optional build metadata (`4.0.0+35896569193` → version and run id). */
export function splitAppVersion(raw: string | undefined): { cleanVersion: string; buildId?: string } {
  const rawVersion = raw && raw.trim() !== '' ? raw.trim() : '1.0.0'
  const plus = rawVersion.indexOf('+')
  if (plus === -1) {
    return { cleanVersion: rawVersion }
  }
  const cleanVersion = rawVersion.slice(0, plus)
  const buildId = rawVersion.slice(plus + 1)
  if (cleanVersion === '' || buildId === '') {
    return { cleanVersion: rawVersion }
  }
  return { cleanVersion, buildId }
}

export function formatAppVersionTitle(raw: string | undefined): string {
  const { cleanVersion, buildId } = splitAppVersion(raw)
  if (buildId) {
    return `v${cleanVersion} (build ${buildId})`
  }
  return `v${cleanVersion}`
}
